import { storageApi } from '../sdk'

export const STORAGELINKPREFIX = '[STORAGELINK]'

function checkForManualSharedRoute(fullPath: string): null | string {
  const parts = fullPath.split('/').filter(e => e.length > 0)

  let secret: string | null = null

  if (fullPath.startsWith('/manual/shared')) {
    secret = parts[2]
  }
  return secret
}

export function createLinkFromSameStoragelink(editString: string, endsubtract?: number): string {
  const route = useRoute('client-view-path')
  const storage = route.fullPath.split('/').filter(e => e.length > 0)[2]
  // const storage = route.fullPath.substring(route.fullPath.lastIndexOf('/'))
  const client = route.params.client

  // eslint-disable-next-line node/prefer-global/process
  const dev = process.env.NODE_ENV === 'development'

  const baseUrl = `${dev ? 'http' : 'https'}://${window.location.hostname}${dev ? ':3000' : ''}`

  const secret = checkForManualSharedRoute(route.fullPath)

  const linkStart = !secret ? (editString.indexOf(STORAGELINKPREFIX) + STORAGELINKPREFIX.length) : (editString.lastIndexOf('/') + 1)
  const linkEnd = (editString.length) - (endsubtract ?? 0)

  const target = editString.substring(linkStart, linkEnd)

  if (!secret) {
    return `${baseUrl}/${client}/view/${storage}/${encodeURIComponent(decodeURI(target))}`
  }
  else {
    return `${baseUrl}/manual/shared/${secret}/${target}`
  }
}

export async function createLinkFromRemoteStoragelink(editString: string, endsubtract?: number): Promise<string> {
  const route = useRoute('client-view-path')
  const storage = route.fullPath.split('/').filter(e => e.length > 0)[2]
  // const storage = route.fullPath.substring(route.fullPath.lastIndexOf('/'))
  const client = route.params.client

  // eslint-disable-next-line node/prefer-global/process
  const dev = process.env.NODE_ENV === 'development'

  const baseUrl = `${dev ? 'http' : 'https'}://${window.location.hostname}${dev ? ':3000' : ''}`

  const secret = checkForManualSharedRoute(route.fullPath)

  const linkStart = !secret ? (editString.indexOf(STORAGELINKPREFIX) + STORAGELINKPREFIX.length) : (editString.lastIndexOf('/') + 1)
  const linkEnd = (editString.length) - (endsubtract ?? 0)

  const target = editString.substring(linkStart, linkEnd)

  if (!secret) {
    const targetClient = route.path.substring(1, route.path.indexOf('/', 1))
    const path = `${storage}/${decodeURI(target)}`
    const alternatives = await storageApi.alternativesInstance(targetClient, path)
    if (alternatives.length > 0) { // found an alternative path for the current instance, link to that
      return `${baseUrl}/${client}/view/${alternatives[0].storageName}/${encodeURIComponent(alternatives[0].path)}`
    }

    // couldnt find an alternative, keep it as is then
    return `${baseUrl}/${client}/view/${storage}/${encodeURIComponent(target)}`
  }
  else {
    return `${baseUrl}/manual/shared/${secret}/${target}`
  }
}
